import { createAsyncThunk } from "@reduxjs/toolkit";
import { UsersAPI } from "api/api/usersApi/usersApi";
import axios from "axios";
import { PostUsersBody, PostUsersResponse } from "api/api/usersApi/types";

export const postUsers = createAsyncThunk<
  PostUsersResponse,
  PostUsersBody
>(
  "users/postUsers",
  async (body, { rejectWithValue }) => {
    try {
      const response = await UsersAPI.postUsers(body);
      return response.data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while posting users", error.response?.data);
        return rejectWithValue(error.response?.data || "Unknown error");
      }
      else {
        console.error("Error while posting users", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  })